import slugify from "slugify"
import React from "react"
import { SinglePathSVG } from "../SVG"
import { HR, Spacer } from "../atoms/Atoms"
import L10n from "../../../lib/carrot-l10n"
import Helpers from "../../../utils/Helpers"
import LibraryMarkdown from "./LibraryMarkdown"
import { HashLink } from "react-router-hash-link"
import { BodySmall } from "../atoms/Bodies"
import { Header } from "components/views/atoms/Header"
import { H1, H5 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const BreadCrumbLink = ({ to, children, weight }) => (
  <H5>
    <HashLink to={to} className={`${weight} no-underline black-80 ml1`}>
      {children}
    </HashLink>
  </H5>
)

const BreadCrumbArrow = () => (
  <div className="mh2 black-60">
    <SinglePathSVG icon="rightCarrotSmall" />
  </div>
)

const LibraryBreadcrumbs = ({ categoryTitle, hasManySubCategories, subCategory }) => {
  const subCategorySlug = slugify(subCategory.fields.navTitle || subCategory.fields.title)
  const libraryUrl = "/read"
  const categoryUrl = `${libraryUrl}/${slugify(categoryTitle)}`
  const subCategoryUrl = `${categoryUrl}#${subCategorySlug}`

  return (
    <div className="flex items-center" style={{ marginBottom: "6px" }}>
      <div className="mr1">
        <BodySmall color="black-60">{l`client.library.readAndLearn`}</BodySmall>
      </div>
      <BreadCrumbArrow />
      <BreadCrumbLink weight={hasManySubCategories ? "normal" : "b"} to={categoryUrl}>
        {categoryTitle}
      </BreadCrumbLink>
      {hasManySubCategories && (
        <>
          <BreadCrumbArrow />
          <BreadCrumbLink to={subCategoryUrl}>{subCategory.fields.navTitle || subCategory.fields.title}</BreadCrumbLink>
        </>
      )}
    </div>
  )
}

const ReadArticleHeader = ({ title, hasManySubCategories, subCategory }) => (
  <div className="w-100">
    <Header
      titleBar={
        <LibraryBreadcrumbs
          categoryTitle={title}
          hasManySubCategories={hasManySubCategories}
          subCategory={subCategory}
        />
      }
    />
  </div>
)

const ReadArticleFooter = ({ hasManySubCategories, subCategory, categoryTitle }) => (
  <>
    <Spacer height={3.5} />
    <HR color="mineral-grey" />
    <Spacer height={1.35} />
    <LibraryBreadcrumbs
      hasManySubCategories={hasManySubCategories}
      subCategory={subCategory}
      categoryTitle={categoryTitle}
    />

    <Spacer height={4} />
  </>
)

const LastUpdatedTag = ({ lastUpdated }) => (
  <>
    <Spacer height={2.5} />
    <div style={{ width: 47 }}>
      <HR width={3} color="black-10" />
    </div>
    <Spacer height={0.75} />
    <BodySmall color="black-80">Last updated: {Helpers.formatDate(lastUpdated, "MM/DD/YYYY")}</BodySmall>
  </>
)

const ReadArticle = ({
  articleBody,
  articleTitle,
  categoryTitle,
  hasManySubCategories,
  isVideo,
  lastUpdated,
  subCategory,
  videoUrl
}) => (
  <>
    <ReadArticleHeader hasManySubCategories={hasManySubCategories} subCategory={subCategory} title={categoryTitle} />
    <div className="flex justify-center w-100">
      <div className={`${isVideo ? "mw-800 w-100" : "mw-606"}`}>
        <Spacer height={3} />
        <H1>
          <span style={{ fontSize: 40 }}>{articleTitle}</span>
        </H1>
        <Spacer height={0.5} />
        {isVideo ? (
          <div className="embed-container">
            <iframe className="bn" title={articleTitle} src={videoUrl} frameBorder="0" allowFullScreen />
          </div>
        ) : (
          <LibraryMarkdown source={articleBody} additionalClasses="publico-text black-80" />
        )}
        <LastUpdatedTag lastUpdated={lastUpdated} />
      </div>
    </div>
    <ReadArticleFooter
      hasManySubCategories={hasManySubCategories}
      subCategory={subCategory}
      categoryTitle={categoryTitle}
    />
  </>
)

export default ReadArticle
export { LibraryBreadcrumbs }
